import moment from 'moment-timezone'

export default {
  data () {
    return {
      showOnlySelected: false,
      subConfigMax: null,
      subConfigMin: null,
      subConfigsGroupNames: ['spending total', 'average spend', 'visiting total', 'order type'],
    }
  },

  computed: {
    displayDate() {
      let formattedDate = null
      if (moment && this.subConfigMax && this.subConfigMin) {
        const  dateFormat = this.showOnlySelected ? 'MM/DD/YYYY' : 'YY-MM-DD',
          connector = this.showOnlySelected ? '-' : 'to',
          max = moment(this.subConfigMax).format(dateFormat),
          min = moment(this.subConfigMin).format(dateFormat)
        formattedDate = `${min} ${connector} ${max}`
      }
      return formattedDate
    },
  },
}